import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Menuria from "./plugins/menuria";
import apolloProvider from "./apollo";
import VueCompositionAPI from "@vue/composition-api";

Vue.config.productionTip = false;

Vue.use(Menuria);
Vue.use(VueCompositionAPI);

const app = new Vue({
  router,
  store,
  apolloProvider,
  render: (h) => h(App),
});

store["$app"] = app;
app.$mount("#app");
